<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="600px"
      @click:outside="hide"
    >
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-file-input
          v-model="file"
          accept=".jpg,.jpeg,.png"
          label="Picture"
          class="px-6"
          prepend-icon="mdi-camera"
          @change="changeImage"
        ></v-file-input>
        <v-label>
          Display lang muna 'yung cropper. Walang ginagawa 'yan.
        </v-label>
        <vue-cropper
          id="cropper"
          ref="cropper"
          :class="{ circular, 'mx-4': true, 'mb-2': true }"
          alt="Crop image"
          v-if="src"
          :src="src"
          :aspect-ratio="aspectRatio"
          :view-mode="2"
          style="max-width: 100%; height: 360px;"
        ></vue-cropper>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="hide"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!src"
            @click="submitImage"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="uploading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        class="px-2 pt-3"
        dark
      >
        <v-card-text>
          Uploading... ({{ uploadProgress }}%)
          <v-progress-linear
            :value="uploadProgress"
            color="white"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import { randomId } from '../utils'

export default {
  name: 'ImageUploadDialog',
  components: {
    VueCropper
  },
  props: {
    title: {
      type: String,
      default: 'Upload picture'
    },
    aspectRatio: {
      type: Number,
      default: NaN
    },
    circular: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      src: '',
      file: null,
      uploadProgress: 0
    }
  },
  computed: {
    uploading() {
      return this.uploadProgress > 0
    }
  },
  methods: {
    show() {
      this.dialog = true
    },
    hide() {
      this.dialog = false
      this.uploadProgress = 0
      setTimeout(() => this.removeImage(), 200)
    },
    changeImage(file) {
      if (file == null)
        return this.removeImage()

      const reader = new FileReader()
      reader.onload = e => {
        this.src = e.target.result
        this.$refs.cropper.replace(this.src)
      }
      reader.readAsDataURL(file)
    },
    removeImage() {
      this.src = ''
      this.$refs.cropper.replace('')
      this.file = null
    },
    async submitImage() {
      const storage = firebase.storage()
      const ref = storage.ref().child(`img/${randomId()}.png`)
      // const cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const uploadTask = ref.putString(this.src, 'data_url')

      uploadTask.on('state_changed', snap => {
        const progress = (snap.bytesTransferred / snap.totalBytes) * 100
        this.uploadProgress = Math.floor(Math.max(1, progress))
      }, err => {
        alert('An error occurred while uploading')
        console.error(err)
        this.hide()
      }, async () => {
        this.$emit('upload', await ref.getDownloadURL())
        this.hide()
      })
    },
    getBase64Image() {
      const reader = new FileReader()
      return reader.readAsDataURL(this.file)
    }
  }
}
</script>

<style>
.circular .cropper-view-box {
  border-radius: 50%;
}

.circular .cropper-face {
  background-color: inherit !important;
}
</style>